const LogOut = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M8.125 11.5625C8.64277 11.5625 9.0625 11.1428 9.0625 10.625C9.0625 10.1072 8.64277 9.6875 8.125 9.6875C7.60723 9.6875 7.1875 10.1072 7.1875 10.625C7.1875 11.1428 7.60723 11.5625 8.125 11.5625ZM11.25 1.875C11.25 1.69275 11.1705 1.51958 11.0322 1.40085C10.8939 1.28211 10.7107 1.22964 10.5306 1.25718L1.78056 2.59468C1.47539 2.64133 1.25 2.90379 1.25 3.2125V16.7875C1.25 17.0962 1.47535 17.3586 1.78047 17.4053L10.5305 18.7441C10.7106 18.7717 10.8939 18.7192 11.0322 18.6005C11.1704 18.4817 11.25 18.3085 11.25 18.1263V10L17.7153 10L16.4692 11.0922C16.2098 11.3195 16.1835 11.7143 16.4105 11.9741C16.6374 12.2339 17.0316 12.2602 17.291 12.0329L19.7869 9.84537C19.9223 9.72669 20 9.55524 20 9.37501C20 9.19479 19.9223 9.02333 19.7869 8.90465L17.291 6.71715C17.0316 6.48985 16.6374 6.51617 16.4105 6.77595C16.1835 7.03572 16.2098 7.43057 16.4692 7.65787L17.7153 8.75002L11.25 8.75002V1.875ZM10 2.6028V17.3984L2.5 16.2509V3.74923L10 2.6028ZM13.125 17.5H12.5V11.25H13.75V16.875C13.75 17.2202 13.4702 17.5 13.125 17.5ZM12.5 7.5V2.5H13.125C13.4702 2.5 13.75 2.77983 13.75 3.125V7.5H12.5Z"
      fill="currentColor"
    />
  </svg>
);

export default LogOut;
